<app-empty-state
    [className]="'questionnaire-empty-screen'"
    [type]="imgType"
    i18n-title
    title="Congratulations!"
>
    @if (type === 'mandatory_questions_finished') {
    <span i18n
        >Thank you for providing answers to the questionnaire. This questionnaire is used by the Cyber Intelligence Fusion Cell (CIFC) to
        tailor the MDR service to your environment. We encourage you to complete the questionnaire at your earliest convenience for optimal
        service.</span
    >
    } @if (type === 'entire_questionnaire_finished') {
    <span i18n>
        Thank you for completing the questionnaire. This questionnaire is used by the Cyber Intelligence Fusion Cell (CIFC) to deliver a
        customized MDR service. Please revisit the questionnaire periodically and review your answers to ensure the data provided are
        current.</span
    >
    }
    <br />
    @if (type === 'mandatory_questions_finished') {
    <button
        mat-flat-button
        color="primary"
        type="submit"
        class="m-t-20"
        (click)="onResumeQuestionnaire($event)"
        i18n
    >
        Continue
    </button>
    }
</app-empty-state>
